<app-request-list
    [requestOptions]="requestOptions"
    [currentUser]="currentUser">
</app-request-list>


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/view-request/request-list-page/request-list-page.component.html